import { useScript } from "~/common/hooks/useScript";
interface Props {
  greaseAppUrl: string;
}

const IFRAME_ID = "greaseAppIframe";

export const GreaseAppTab = (props: Props) => {
  const { greaseAppUrl } = props;

  useScript("https://cdn.schaeffler-ecommerce.com/ecom/common/iframeResizer.min.js", () =>
    (window as any).iFrameResize({ log: false }, `#${IFRAME_ID}`),
  );

  return (
    <div className={"w-100"}>
      <iframe className="scha__pdp-iframe" id={IFRAME_ID} src={greaseAppUrl} scrolling="yes" />
    </div>
  );
};
